var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhotoLibrary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Photo library",
    clipPath: "url(#clip0_9612_80)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.1654 10.6673V2.66732C15.1654 1.93398 14.5654 1.33398 13.832 1.33398H5.83203C5.0987 1.33398 4.4987 1.93398 4.4987 2.66732V10.6673C4.4987 11.4007 5.0987 12.0007 5.83203 12.0007H13.832C14.5654 12.0007 15.1654 11.4007 15.1654 10.6673ZM7.83203 8.00065L9.18536 9.80732L11.1654 7.33398L13.832 10.6673H5.83203L7.83203 8.00065ZM1.83203 4.00065V13.334C1.83203 14.0673 2.43203 14.6673 3.16536 14.6673H12.4987V13.334H3.16536V4.00065H1.83203Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9612_80"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhotoLibrary);
export default __webpack_public_path__ + "static/media/photo-library.72477f1a0dda83af6c46cc290ce5917b.svg";
export { ForwardRef as ReactComponent };